<template>
  <div>
    Réméré
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Remere'
}
</script>
